//import drivers from '../assets/data/drivers'
import Vue from 'vue'
import axios from 'axios'
import * as _ from 'lodash';

export const DRIVER_STATUS_ACTIVE = 10;
export const DRIVER_STATUS_INACTIVE = 20;
export const DRIVER_STATUS_REGISTRED = 30;

export default {
    state: {
        user: {},
        drivers: [],
        promisesStatus: {},
    },
    mutations: {
        fetchDrivers(state, payload, status=10) {
            // add full_name
            for(let i = 0; i < payload.length; i++ ) {
                payload[i].full_name = payload[i].first_name  + ' ' + payload[i].last_name;
            }
            // default order by name
            if (state.drivers.length >0) {
                (state.drivers).push(...payload);
            } else {
                state.drivers = _.orderBy(payload, driver => driver.full_name);
            }
        },
        setUser(state, payload) {
            state.user = payload
        },
        setDrivers(state, payload) {
            state.drivers = payload;
            console.log(state.drivers);
        },
        addDriversToList(state, payload) {
            // fix to prevent double insert(from http and Socket.io), check is driver already inserted (by this application instance)
            payload.full_name = payload.first_name  + ' ' + payload.last_name;
            let driver = _.find(state.drivers, p => p.id == payload.id);
            if (driver) {
                return; // exit
                //? or pass to update
            }

            (state.drivers).push(payload);
        },
        editDriver(state, payload) {
            payload.full_name = payload.first_name  + ' ' + payload.last_name;
            const index = state.drivers.findIndex(item => item.id === payload.id);
            Vue.set(state.drivers, index, payload);
        },
        messageDriver(/*state, payload*/) {
            // --
        },
        editWorkingTimes(state, payload) {
            payload.full_name = payload.first_name  + ' ' + payload.last_name;
            const index = state.drivers.findIndex(item => item.id === payload.id);
            Vue.set(state.drivers, index, payload);
        },
        setPromiseStatus(state, { promiseName, status }) {
            state.promisesStatus[promiseName] = status;
        },
    },

    actions: {
        async fetchDrivers({ commit, dispatch }, status = 10) {
            let promiseName = `fetchDrivers_${status}`;
            if (!this.state.drivers.promisesStatus[promiseName]) {
                commit('clearError')
                commit('setLoading', true);

                let user = JSON.parse(localStorage.getItem("user"));
                try {
                    let { data } = await axios.get(`${this._vm.appConfig.app_url}/api/driver`, {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            "Authorization": `Bearer ${user.access_token}`
                        },
                        params: {
                            'status': status
                        }
                    });

                    commit('setLoading', false);
                    commit('fetchDrivers', data, status);
                    commit('setPromiseStatus', { promiseName: promiseName, status: true });
                } catch(error) {
                    commit('setLoading', false);

                    if (error.response) {
                        let errors = error.response;
                        if (errors.status == 401) {
                            dispatch('logOutUser');
                            window.location.reload();
                        }
                        if(errors.status == 400) {
                            dispatch('setError', _.values(errors.data)[0][0]);
                            return Promise.reject(errors.data);
                        }
                    }

                    if (error.message) {
                        dispatch('setError', error.message);
                    } else {
                        dispatch('setError', error);
                    }
                }
            }
        },
        async registerUser({commit}/*, payload*/) {
            commit('clearError')
            commit('setLoading', true)

            try {
                commit('setLoading', false)
            } catch (error) {
                commit('setLoading', false)
                commit('setError', error.message)
                throw error
            }
        },
        async createNewDriver({commit, dispatch}, {payload, params}) {
            commit('clearError')
            commit('setLoading', true)

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let { data } = await axios.post(`${this._vm.appConfig.app_url}/api/driver`, payload, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    },
                    params: params // halfBoard: true|false
                });

                commit('setLoading', false);
                commit('addDriversToList', data)
                return data;
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }

                throw error;
            }
        },

        async loginUser({commit}/*, {email, password}*/) {
            commit('clearError')
            commit('setLoading', true)
            // let drivers = this.state.drivers.drivers;

            try {
                // let credential = {
                //     'email': email,
                //     'password': password
                // };
                commit('setLoading', false)
            } catch (error) {
                commit('setLoading', false)
                commit('setError', error.message)
                throw error
            }
        },

        async logOutUser({commit}) {
            commit('clearError')
            commit('setLoading', true)
            try {
                commit('setUser', null);
                commit('setLoading', false);
                localStorage.removeItem("user");
            } catch (error) {
                commit('setLoading', false)
                commit('setError', error.message)
                throw error
            }
        },
        async editDriver({commit, dispatch}, driver_data) {
            commit('clearError')
            commit('setLoading', true)

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let { data } = await axios.put(`${this._vm.appConfig.app_url}/api/driver/${driver_data.id}`, driver_data, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    },
                    params: {
                        'inactive': 'false'
                    }
                });

                commit('setLoading', false);
                commit('editDriver', data);
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }

                throw error;
            }
        },
        
        async messageDriver({commit, dispatch}, payload) {
            commit('clearError')
            commit('setLoading', true)

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let { data } = await axios.post(`${this._vm.appConfig.app_url}/api/driver-message`, payload, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    }
                });

                commit('setLoading', false);
                commit('messageDriver', data);
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }

                throw error;
            }
        },
        
        async setDriverStatus({commit, dispatch}, {driver_id, status}) {
            commit('clearError')
            commit('setLoading', true)

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let { data } = await axios.put(`${this._vm.appConfig.app_url}/api/driver/${driver_id}`, {'status':status}, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    },
                    params: {
                        'inactive':'true'
                    }
                });

                commit('setLoading', false);
                commit('editDriver', data);
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }
            }
        },
        async setDriverProgressing({commit, dispatch}, {driver_id, not_progressing}) {
            commit('clearError')
            commit('setLoading', true)

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let { data } = await axios.put(`${this._vm.appConfig.app_url}/api/driver/${driver_id}`, {'not_progressing':not_progressing}, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    },
                    params: {
                        'progressing':'true'
                    }
                });

                commit('setLoading', false);
                commit('editDriver', data);
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }
            }
        },
        async editWorkingTimes({commit, dispatch}, payload) {
            commit('clearError')
            commit('setLoading', true)

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let { data } = await axios.post(`${this._vm.appConfig.app_url}/api/driver-update-working-times`, payload, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    }
                });

                commit('setLoading', false);
                commit('editWorkingTimes', data);
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }

                throw error;
            }
        },

        /*autoLoginUser({commit}, payload) {
            commit('setUser', payload)
        },*/

    },

    getters: {
        user(state) {
            return state.user
        },
        drivers(state) {
            return _.filter(state.drivers, driver => driver.status == DRIVER_STATUS_ACTIVE);
        },
        allDrivers(state) {
            return state.drivers
        },
        isUserLoggedIn(state) {
            return state.user !== null
        },
    }
}